import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchLookup } from '@repository/lookupRepository';
import { minutesToMillis } from '@utils/millis';
import { paramsAreFilled } from '@utils/paramsAreFilled';
import { FetchLookupError, FetchLookupResponse } from '@models/lookup/FetchLookup';
import useFeatureFlags from '@hooks/useFeatureFlags';

export type Params = {
    [key: string]: string;
};

export const OPTIONAL_KEY = '|OPTIONAL';

const useFetchLookup = (lookup: string | null, params: Params, ignoreMissingFields: boolean, enabled: boolean) => {
    const { featureFlagCachedLookups } = useFeatureFlags();

    return useQuery<FetchLookupResponse, FetchLookupError>({
        queryKey: [QueryKey.Lookup, lookup, JSON.stringify(params)],
        queryFn: ({ signal }) => {
            if (!enabled || !params || !paramsAreFilled(lookup, params, ignoreMissingFields) || !lookup) {
                return Promise.reject();
            }
            return fetchLookup(lookup, params, featureFlagCachedLookups, { signal });
        },
        enabled: enabled && !!params && paramsAreFilled(lookup, params, ignoreMissingFields) && !!lookup,
        staleTime: minutesToMillis(30),
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useFetchLookup;
